import { externalContentsConstants } from '../constants'
import update from 'react-addons-update';
import { imageUploaderConstants } from '../constants/imageUploader.constants';

const initialState = {
  contentFields: {
    title: '',
    link: '',
    description: '',
    status: true,
    highlight: false,
    fixed: false,
  },
  status: 'all',
  externalContents: [],
  externalContent: {},
  paging: {
    page: 1,
    limit: 10,
    sort: { created: -1 },
    total: 0,
    search: ''
  },
  loading: false
}

export const externalContent = (state = initialState, action) => {
  switch (action.type) {
    case externalContentsConstants.GET_EXTERNAL_CONTENT_LIST_REQUEST:
      return {
          ...state,
          loading: true
      }
    case externalContentsConstants.GET_EXTERNAL_CONTENT_LIST_SUCCESS:
      return update(state, {
        externalContents: { $set: action.payload.data },
        paging: {
          // TODO: Change total to paging data
          total: { $set: action.payload.data.length },
          page: { $set: parseInt(action.payload.paging.page) },
          search: { $set: action.payload.query },
          limit: { $set: action.payload.paging.limit },
        },
        loading: {
          $set: false,
        },
      });

    case externalContentsConstants.TOGGLE_FILTER:
      return {
        ...state,
        status: action.payload,
      }

    case externalContentsConstants.SET_EXTERNAL_CONTENT_LOADING:
      return update(state, {
        loading: {
          $set: action.payload
        }
      })

    case externalContentsConstants.SET_EXTERNAL_CONTENT_DATA:
      const { _id, title, link, description, status, highlight, fixed, createdAt } = action.payload;
      const fields =  { _id, title, link, description, status, highlight, fixed, createdAt };
      return update(state, {
        contentFields: { $set: action.payload },
      })

    case externalContentsConstants.SET_NEW_CONTENT:
      return update(state, {
        contentFields: {
          [action.payload.name]: { $set: action.payload.value }
        }
      });

    case externalContentsConstants.SET_NEW_CONTENT_SWITCH:
      return update(state, {
        contentFields: {
          [action.payload.name]: { $set: action.payload.checked }
        }
      });

    case imageUploaderConstants.IMAGEUPLOAD_REMOVE_IMAGE:
      return update(state, {
        contentFields: {
          attachment: { $set: {} }
        }
      });

    case externalContentsConstants.CLEAR_CONTENT_FIELDS:
      return update(state, { contentFields: { $set: initialState.contentFields } });

    case externalContentsConstants.GET_ALL_EXTERNAL_CONTENTS_REQUEST:
    case externalContentsConstants.GET_EXTERNAL_CONTENTS_BY_STATUS_REQUEST:
      return {
        ...state,
        loading: true
      }

    case externalContentsConstants.GET_ALL_EXTERNAL_CONTENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        externalContents: action.payload.data,
        paging: {
          page: action.payload.paging.page,
          sort: action.payload.paging.sort,
          limit: action.payload.paging.limit,
          search: action.payload.searchText,
          total: action.payload.paging.total
        }
      }

    case externalContentsConstants.GET_EXTERNAL_CONTENTS_BY_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        externalContents: action.payload.data,
        paging: {
          page: action.payload.paging.page,
          sort: action.payload.paging.sort,
          limit: action.payload.paging.limit,
          total: action.payload.paging.total
        }
      }

    case externalContentsConstants.GET_ALL_EXTERNAL_CONTENTS_FAILURE:
    case externalContentsConstants.GET_EXTERNAL_CONTENTS_BY_STATUS_FAILURE:
      return {
        ...state,
        loading: false,
      }

    
    case externalContentsConstants.EXTERNAL_CONTENT_CLEAR_ALL:
      return initialState;

    default:
      return state;
  }
}